<template>
  <div class="card shadow" style="min-height: 100%">
    <a-modal title="Warning" :visible="modalVisible" @ok="massupdate('status', 'D')" @cancel="modalVisible = false">
      All changes to be made cannot be reverted. Are you sure you want to delete
      the selected products?
    </a-modal>

    <div class="card-header border-0" :class="type === 'dark' ? 'bg-transparent' : ''">
      <div class="row align-items-center">
        <div id="errorNotification" class="col-md-12">
          <base-alert v-if="errorMessage != null" type="danger">
            <span class="alert-inner--text"> {{ errorMessage }}</span>
            <button type="button" class="close" aria-label="Close" @click="removeMessage('error')">
              <span aria-hidden="true">&times;</span>
            </button>
          </base-alert>
          <base-alert v-if="successMessage != null" type="success">
            <span class="alert-inner--text"> {{ successMessage }}</span>
            <button type="button" class="close" aria-label="Close" @click="removeMessage('success')">
              <span aria-hidden="true">&times;</span>
            </button>
          </base-alert>
          <stock-card v-if="selectedProduct != null" :product="selectedProduct" :key="stockCardKey" :icon_code="icon_code"
            :visible="stockCardVisible"></stock-card>
        </div>

        <div class="col-md-6">
          <h2>{{ this.title }}</h2>
        </div>

        <div class="col-md-6 text-right">
          <!-- <div v-if="massUpdateMode == true">" -->
          <base-dropdown class="nav-link pr-0 float-right" position="right"
            v-if="massUpdateMode == false || massUpdateMode == null">
            <div class="media align-items-center" slot="title">
              <i class="fa fa-ellipsis-v float-right ml-2 btn-sm"></i>
            </div>
            <template>
              <div class="dropdown-header noti-title">
                <h6 class="text-overflow m-0">PRODUCT LIST ACTIONS</h6>
              </div>
              <!-- <div v-if="accessRights.includes('T')" class="dropdown-item"
                @click.prevent="showActionDrawer('print_list')">
                <i class="fa fa-print"></i>
                <span>Print</span>
              </div> -->
              <div v-if="serverType == 'ho' && accessRights.includes('I')" class="dropdown-item"
                @click.prevent="showActionDrawer('import_list')">
                <i class="fa fa-upload"></i>
                <span>Import</span>
              </div>
              <div v-if="accessRights.includes('E') && showAdvanceImportExportModule" class="dropdown-item"
                @click.prevent="showActionDrawer('advanced_import_list')">
                <i class="fa fa-download"></i>
                <span>Advanced Import</span>
              </div>
              <div v-if="accessRights.includes('E')" class="dropdown-item"
                @click.prevent="showActionDrawer('export_list')">
                <i class="fa fa-download"></i>
                <span>Export</span>
              </div>
              <div v-if="accessRights.includes('E') && showAdvanceImportExportModule" class="dropdown-item"
                @click.prevent="showActionDrawer('advanced_export_list')">
                <i class="fa fa-download"></i>
                <span>Advanced Export</span>
              </div>
              <div v-if="serverType == 'ho' && accessRights.includes('W')" class="dropdown-divider"></div>
              <div v-if="serverType == 'ho' && accessRights.includes('W')" class="dropdown-header noti-title">
                <h6 class="text-overflow m-0">PRODUCT UPDATES ACTIONS</h6>
              </div>
              <div v-if="serverType == 'ho' && accessRights.includes('W')" class="dropdown-item"
                @click.prevent="changeMode">
                <i class="fa fa-object-group"></i>
                <span>Mass Update Products</span>
              </div>
              <div class="dropdown-divider"></div>
              <div class="dropdown-header noti-title">
                <h6 class="text-overflow m-0">PX SETTINGS</h6>
              </div>
              <div class="dropdown-item" @click.prevent="showActionDrawer('customize_list')">
                <i class="fa fa-list-ul"></i>
                <span>Customize List</span>
              </div>
              <div v-if="serverType == 'ho'" class="dropdown-item" @click.prevent="showActionDrawer('configuration')">
                <i class="fa fa-cog"></i>
                <span>Configuration</span>
              </div>
              <div class="dropdown-item" @click.prevent="showActionDrawer('configurationhist')">
                <i class="fa fa-history"></i>
                <span>Configuration History</span>
              </div>
            </template>
            <!-- <template v-else>
              <div class=" dropdown-header noti-title">
                <h6 class="text-overflow m-0">MASS UPDATE ACTIONS</h6>
              </div>
              <div class="dropdown-item" @click.prevent="showActionDrawer('print_list')">
                <i class="fa fa-check-circle"></i>
                <span>Select All</span>
              </div>
            </template> -->
          </base-dropdown>

          <div v-if="massUpdateMode == false || massUpdateMode == null">
            <!-- {{this.accessRights}} -->
            <div v-if="serverType == 'ho' && site_type == 'ho'">
              <div v-if="selectedRowKeys.length == 0 && accessRights.includes('A')">
                <base-dropdown class="nav-link" position="right">
                  <div class="media align-items-center" slot="title">
                    <base-button class="float-right ml-1" type="primary" size="sm">+ Add
                      {{
                          _.startCase(_.singularize(currentProfile))
                      }}</base-button>
                  </div>
                  <template>
                    <div class="dropdown-header noti-title">
                      <h6 class="text-overflow m-0 text-muted">
                        SELECT PRODUCT TYPE
                      </h6>
                    </div>
                    <div v-if="enable_regular == true" class="dropdown-item" @click.prevent="showDrawer(0, '', 0)">
                      <img class="product-icons" :src="require(`../../assets/icons/${icon_code}/regular.png`)" alt="">
                      <span>Regular Product</span>
                    </div>
                    <div v-if="enable_combo == true && icon_code == 'FNB'" class="dropdown-item" @click.prevent="showDrawer(0, 'B', 0)">
                      <img class="product-icons" :src="require(`../../assets/icons/${icon_code}/combo.png`)" alt="">
                      <span>Combo Product</span>
                    </div>
                    <div v-if="enable_packaged == true" class="dropdown-item" @click.prevent="showDrawer(0, 'P', 0)">
                      <img class="product-icons" :src="require(`../../assets/icons/${icon_code}/packaged.png`)" alt="">
                      <span>Packaged Product</span>
                    </div>
                    <div v-if="enable_matrix == true" class="dropdown-item" @click.prevent="showDrawer(0, 'M', 0)">
                      <img class="product-icons" :src="require(`../../assets/icons/${icon_code}/matrix.png`)" alt="">
                      <span>Matrix Product</span>
                    </div>
                    <div v-if="enable_kit == true" class="dropdown-item" @click.prevent="showDrawer(0, 'K', 0)">
                      <img class="product-icons" :src="require(`../../assets/icons/${icon_code}/kit.png`)" alt="">
                      <span>Kit</span>
                    </div>
                    <div v-if="enable_virtual_kit == true" class="dropdown-item" @click.prevent="showDrawer(0, 'V', 0)">
                       <img class="product-icons" :src="require(`../../assets/icons/${icon_code}/virtual_kit.png`)" alt="">
                      <span>Virtual Kit</span>
                    </div>
                    <div v-if="enable_non_inventory" class="dropdown-item" @click.prevent="showDrawer(0, 'N', 0)">
                       <img class="product-icons" :src="require(`../../assets/icons/${icon_code}/non_inventory.png`)" alt="">
                      <span>Non-Inventory Tracking Item</span>
                    </div>
                    <div v-if="enable_serial == true" class="dropdown-item" @click.prevent="showDrawer(0, 'S', 0)">
                      <img class="product-icons" :src="require(`../../assets/icons/${icon_code}/serial.png`)" alt="">
                      <span>Serial Item</span>
                    </div>
                    <div v-if="enable_recipe == true  && icon_code == 'FNB'" class="dropdown-item" @click.prevent="showRecipeDrawer(0)">
                       <img class="product-icons" :src="require(`../../assets/icons/${icon_code}/recipe.png`)" alt="">
                      <span>Recipe</span>
                    </div>
                  </template>
                </base-dropdown>
              </div>

              <div v-else-if="
                selectedRowKeys.length > 0 && accessRights.includes('W')
              ">
                <base-button class="float-right ml-1 mt-1" type="danger" size="sm" @click.prevent="modalVisible = true">
                  Delete Selected</base-button>
                <base-dropdown class="nav-link" position="right">
                  <div class="media align-items-center" slot="title">
                    <base-button class="float-right ml-1" type="info" size="sm">Change Status</base-button>
                  </div>
                  <template>
                    <div class="dropdown-header noti-title">
                      <h6 class="text-overflow m-0 text-muted">
                        Select Status
                      </h6>
                    </div>
                    <div class="dropdown-item" @click.prevent="massupdate('status', 'A')">
                      <span>Active</span>
                    </div>
                    <div class="dropdown-item" @click.prevent="massupdate('status', 'I')">
                      <span>Inactive</span>
                    </div>
                    <div class="dropdown-item" @click.prevent="massupdate('status', 'P')">
                      <span>Phased Out</span>
                    </div>
                  </template>
                </base-dropdown>
              </div>
            </div>
          </div>

          <div v-if="massUpdateMode == true">
            <small> {{ this.productList.length }} products selected </small>
            <button type="button" class="btn btn-sm btn-danger ml-2" style="width: 20%" @click.prevent="changeMode">
              Cancel
            </button>
            <!-- <router-link :to="{path: 'product_updates', query: { selected-products: productList }}">Link Text</router-link> -->
            <button type="button" class="btn btn-sm btn-default" style="width: 20%"
              :disabled="this.productList.length == 0" @click.prevent="showMassUpdater">
              Next
            </button>
            <br />
            <button v-if="this.copyData.length > 0" type="button" class="btn btn-sm btn-secondary mt-3 mr-2"
              style="width: 20%" @click.prevent="addAllProduct">
              Select All
            </button>
          </div>
        </div>
      </div>
    </div>

    <a-drawer title="" :width="width" placement="right" @close="onClose" :visible="drawerVisible">
      <div v-if="profileAction == 'configurationhist'">
        <document-configuration-history @closeDrawer="closeDrawer" v-on:refreshPage="refreshPage" :key="componentKey">
          asa</document-configuration-history>
      </div>

      <div v-if="profileAction == 'customize_list'">
        <h6 class="heading-small text-muted mb-4">Customize Fields</h6>
        <small>Check the fields that you want to see on the list. Drag the fields to
          specify position.</small>
        <br /><br />

        <div class="list-group list-group-item">
          <div class="row">
            <div class="col-md-6"><b>AVAILABLE FIELDS</b></div>
            <div class="col-md-6">
              <a-checkbox class="float-right" @change="onCheckAllField" :checked="
                this.checkedFields.length == this.availableFields.length
              " />
            </div>
          </div>
        </div>

        <draggable :key="draggableKey" :list="availableFields" :disabled="!enabled" class="list-group"
          @start="dragging = true" @end="dragging = false">
          <div class="list-group-item" :style="
            index == availableFields.length - 1 ? 'margin-bottom: 50px;' : ''
          " v-for="(element, index) in availableFields" :key="element">
            <div class="row">
              <!-- This _.startCase() will convert any casing into Start Case -->
              <div class="col-md-6">{{ _.startCase(element) }}</div>
              <div class="col-md-6">
                <a-checkbox class="float-right" @change="onCheckField(element)"
                  :checked="checkedFields.includes(element)" />
              </div>
            </div>
          </div>
        </draggable>

        <div class="float-right" style="position: absolute; bottom: 20px; right: 20px">
          <button class="btn btn-primary float-right" @click.prevent="updateTableList">
            Update List
          </button>
        </div>
      </div>

      <div v-if="profileAction == 'export_list'">
        <h6 class="heading-small text-muted mb-4">Export Options</h6>
        <div>
          <base-radio name="0" class="mb-3" v-model="filterStatus" value="O">
            Export All
          </base-radio>
          <base-radio name="2" class="mb-3" v-model="filterStatus" value="2">
            Export Selected
          </base-radio>
          <base-radio name="3" class="mb-3" v-model="filterStatus" value="3">
            Export Filtered
          </base-radio>
          <base-radio name="4" class="mb-3" v-model="filterStatus" value="4">
            Export Site Products
          </base-radio>
        </div>

        <div style="
            position: absolute;
            bottom: 0px;
            right: 0px;
            width: -webkit-fill-available;
            background-color: #f2f2f2;
            padding: 10px;
          ">
          <button type="button" class="btn btn-primary float-right" @click.prevent="download">
            Export
          </button>
        </div>
      </div>
      <div v-if="profileAction == 'advanced_export_list'">
        <h6 class="heading-small text-muted mb-4">Advanced Export Options</h6>
        <div>
          <base-radio name="1" class="mb-3" v-model="filterStatus" value="1">
            Shakey's Product Master Export<br>
            <small>Includes Parent and Child Items, Segment Pricing, and Discount Settings</small>
          </base-radio>
        </div>

        <div style="
            position: absolute;
            bottom: 0px;
            right: 0px;
            width: -webkit-fill-available;
            background-color: #f2f2f2;
            padding: 10px;
          ">
          <button type="button" class="btn btn-primary float-right" @click.prevent="download">
            Export
          </button>
        </div>
      </div>
      <div v-if="profileAction == 'import_list'">
        <h6 class="heading-small text-muted mb-4">Import Options</h6>
        <div>
          <a-upload-dragger :remove="handleRemove" :fileList="fileList" :beforeUpload="beforeUpload" :multiple="false">
            <span class="fa fa-file-import" style="font: 20pt" />
            <p class="ant-upload-text">
              Click or drag file to this area to upload
            </p>
            <p class="ant-upload-hint">
              Upload your product list in a CSV file following the specified
              format. You can download templates below.
            </p>
          </a-upload-dragger>
          <!-- <button type="button" class="btn btn-primary float-right"></button> -->

          <br /><br />
          <a-collapse>
            <a-collapse-panel header="Templates" key="1">
              <a-list bordered>
                <a-list-item>
                  <a-list-item-meta description="Contains required data to create a product">
                    <a @click.prevent="downloadTemplate('1')" slot="title">Download Basic Product Template</a>
                  </a-list-item-meta>
                  <div>
                    <a @click.prevent="downloadTemplate('1')"><span class="fa fa-file-download" /></a>
                  </div>
                </a-list-item>
                <a-list-item>
                  <a-list-item-meta description="Includes extended information about products">
                    <a @click.prevent="downloadTemplate('2')" slot="title">Download Advanced Product Template</a>
                  </a-list-item-meta>
                  <div>
                    <a @click.prevent="downloadTemplate('2')"><span class="fa fa-file-download" /></a>
                  </div>
                </a-list-item>
                <a-list-item>
                  <a-list-item-meta description="Includes matrix information about products">
                    <a @click.prevent="downloadTemplate('3')" slot="title">Download Matrix Product Template</a>
                  </a-list-item-meta>
                  <div>
                    <a @click.prevent="downloadTemplate('3')"><span class="fa fa-file-download" /></a>
                  </div>
                </a-list-item>
              </a-list>
            </a-collapse-panel>
          </a-collapse>
        </div>

        <div style="
            position: absolute;
            bottom: 0px;
            right: 0px;
            width: -webkit-fill-available;
            background-color: #f2f2f2;
            padding: 10px;
          ">
          <button type="button" class="btn btn-primary float-right" @click.prevent="importFile">
            Import
          </button>
        </div>
      </div>
      <div v-if="profileAction == 'advanced_import_list'">
        <product-advanced-import-form></product-advanced-import-form>
      </div>


      <div v-if="profileAction == 'print_list'">
        <h6 class="heading-small text-muted mb-4">Print Options</h6>
      </div>

      <div v-if="profileAction == 'configuration'">
        <h6 class="heading-small text-muted">Product Explorer Configuration</h6>
        <!-- {{settingsGrouping}} -->
        <base-alert v-if="errors.length" type="danger">
          <b>You have the following error(s):</b>
          <li v-for="error in errors" :key="error">{{ error }}</li>
        </base-alert>

        <dynamic-form :convertedJson="convertedJson" :formSettings="formSettings" @valueUpdated="updateSettings">
        </dynamic-form>

        <div class="float-right" style="position: absolute; bottom: 20px; right: 20px">
          <a-spin :tip="spinMessage" :spinning="spinning">
            <button class="btn btn-success" @click.prevent="processSettings">
              Save
            </button>
          </a-spin>
        </div>
      </div>
    </a-drawer>

    <a-drawer title="" :width="windowWidth" placement="right" @close="onClose" :visible="visible">
      <div>
        <product-form @closeDrawer="closeDrawer" v-on:refreshPage="refreshPage" :productType="productType"
          :btnValue="btnValue" :key="componentKey"></product-form>
      </div>
    </a-drawer>

    <a-drawer title="" :width="windowWidth" placement="right" @close="onClose" :visible="recipeVisible">
      <div>
        <recipe-form @closeDrawer="closeDrawer" @refreshPage="refreshPage" :key="recipeKey"></recipe-form>
      </div>
    </a-drawer>

    <div class="table-responsive">
      <!-- {{columns}} -->
      <div v-if="hasSelected" style="margin-bottom: 16px">
        <span style="margin-left: 20px">
          <template>
            <small>{{ `Selected ${selectedRowKeys.length} items` }}</small>
          </template>
        </span>
      </div>

      <div v-if="massUpdateMode == false || massUpdateMode == null">
        <a-table size="small" :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
        }" :columns="columns" :dataSource="data" :scroll="scroll" :loading="loading" :rowKey="(record) => record.id"
          :pagination="pagination" @change="handleTableChange">
          <template slot="name" slot-scope="text, record">
            <a-tooltip>
              <template slot="title">
                {{ record.name }}
              </template>
              <img class="table-product-icons" :src="iconSourcePath(record.product_type)" alt="" />
              {{ _.truncate(record.name, { length: 22, omission: "..." }) }}
            </a-tooltip>
          </template>

          <template slot="status" slot-scope="status">
            {{ status | filterStatusOnTableList }}
          </template>

          <template slot="product_type" slot-scope="product_type">
            {{ product_type | filterProductTypeOnTableList }}
          </template>

          <template slot="action" slot-scope="action">
            <center>
              <div v-if="massUpdateMode == false || massUpdateMode == null">
                <div v-if="serverType == 'ho'" class="table-button-container">
                  <button v-if="accessRights.includes('V')" class="btn btn-success btn-sm"
                    @click.prevent="showModal(action)">
                    History
                  </button>
                  <button v-if="accessRights.includes('V')" class="btn btn-info btn-sm" @click.prevent="
                    showDrawer(action.id, action.product_type, 1)
                  ">
                    View
                  </button>
                  <button v-if="accessRights.includes('W')" class="btn btn-warning btn-sm" @click.prevent="
                    showDrawer(action.id, action.product_type, 0)
                  ">
                    Edit
                  </button>
                  <a-popconfirm title="You are about to delete this record?" @confirm="deleteRow(action.id)"
                    okText="Delete" cancelText="Cancel" v-if="accessRights.includes('D')">
                    <a class="btn btn-danger btn-sm text-white">Delete</a>
                  </a-popconfirm>
                </div>
                <div v-else class="table-button-container">
                  <button class="btn btn-info btn-sm" @click.prevent="
                    showDrawer(action.id, action.product_type, 1)
                  ">
                    View
                  </button>
                  <button class="btn btn-success btn-sm" @click.prevent="showModal(action)">
                    History
                  </button>
                </div>
              </div>
              <div v-else>
                <div v-if="serverType == 'ho'" class="table-button-container">
                  <button v-if="!productListIds.includes(action.id)" class="btn btn-success btn-sm" style="width: 60%"
                    @click.prevent="addToProductList(action)">
                    Add
                  </button>
                  <button v-else class="btn btn-default btn-sm" @click.prevent="addToProductList(action)">
                    Undo
                  </button>
                </div>
              </div>
            </center>
          </template>
        </a-table>
      </div>

      <div v-if="massUpdateMode == true">
        <a-table size="small" :columns="columns" :dataSource="copyData" :scroll="scroll" :loading="loading"
          :rowKey="(record) => record.id" :pagination="pagination" @change="handleTableChange" :key="componentKey">
          <template slot="name" slot-scope="text, record">
            <a-tooltip>
              <template slot="title">
                {{ record.name }}
              </template>
              <img class="product-icons" :src="iconSourcePath(record.product_type)" alt="" />
              {{ _.truncate(record.name, { length: 22, omission: "..." }) }}
            </a-tooltip>
          </template>

          <template slot="status" slot-scope="status">
            {{ status | filterStatusOnTableList }}
          </template>
          <template slot="product_type" slot-scope="product_type">
            {{ product_type | filterProductTypeOnTableList }}
          </template>

          <template slot="action" slot-scope="action">
            <center>
              <div v-if="serverType == 'ho'" class="table-button-container">
                <button v-if="!productListIds.includes(action.id)" class="btn btn-success btn-sm" style="width: 60%"
                  @click.prevent="addToProductList(action)">
                  Add
                </button>
                <button v-else class="btn btn-default btn-sm" @click.prevent="addToProductList(action)">
                  Undo
                </button>
              </div>
            </center>
          </template>
        </a-table>
      </div>
    </div>
  </div>
</template>

<script>
const columns = [
  {
    title: "Name",
    width: 300,
    dataIndex: "name",
    key: "name",
    scopedSlots: { customRender: "name" },
  },
  {
    title: "Barcode",
    width: 200,
    dataIndex: "barcode",
    key: "barcode",
    width: 200,
  },
  {
    title: "Retail Price",
    dataIndex: "retail_price",
    key: "2",
    width: 100,
    align: "right",
  },
  // {
  //   title: "Site Retail Price",
  //   dataIndex: "site_retail_price",
  //   key: "1",
  //   width: 100,
  //   align: "right",
  // },
  // { title: 'Product Type', dataIndex: 'product_type', key: '2', width: 200, scopedSlots: { customRender: 'product_type' }},
  {
    title: "Status",
    dataIndex: "status",
    key: "3",
    width: 100,
    scopedSlots: { customRender: "status" },
    },
  {
    title: "Action",
    key: "operation",
    fixed: "right",
    align: "center",
    width: 300,
    scopedSlots: { customRender: "action" },
  },
];
// Column ends here

import reqwest from "reqwest";
import axios from "axios";
import { mapState, mapActions } from "vuex";

import draggable from "vuedraggable";
import secureStorage from "../../controllers/secureStorage";
import HTTPRequest from "../../controllers/httpRequest.js";
import StockCard from "../Products/StockCard.vue";
import DynamicForm from "../DynamicForm.vue";
import ProductForm from "../Products/ProductForm";
import RecipeForm from "../Products/RecipeForm";
import ValidateField from "../../components/validateFormUtils.js";
import { compareData } from "../../utilities.js";
import moment from "moment";
import DocumentConfigurationHistory from "../Documents/DocumentConfigurationHistory.vue";
import ProductAdvancedImportForm from "../Products/AdvancedImportForm.vue"

var ObjGen = require("../../../node_modules/objgen/objgen.js").ObjGen;

var component_x;

export default {
  components: {
    StockCard,
    ProductForm,
    DynamicForm,
    RecipeForm,
    draggable,
    DocumentConfigurationHistory,
    ProductAdvancedImportForm
  },
  computed: {
    ...mapState([
      "currentProfile",
      "currentApiURL",
      "endPoint",
      "profileId",
      "parameters",
      "parentId",
      "serverType",
    ]),
    hasSelected() {
      return this.selectedRowKeys.length > 0;
    },
  },
  filters:{
    filterStatusOnTableList(value){
      if(value == 'A'){
        return 'Active';
      }else{
        return 'Inactive';
      }
    },
    filterProductTypeOnTableList(value){
      var productType = "";
      switch(value){
        case '':
          productType = "Regular";
          break;
        case 'P':
          productType = "Package";
          break;
        case 'N':
          productType = "Non-Inventory";
          break;
        case 'S':
          productType = "Serial";
          break;
        case 'K':
          productType = "Kit Item";
          break;
        case 'V':
          productType = "Virtual Kit";
          break;
        case 'M':
          productType = "Matrix";
          break;
        case 'B':
          productType = "Combo";
          break;
        case 'R':
          productType = "Recipe";
          break;
        default:
          productType = "Regular";
          break;
      }
      return productType;
    }
  },
  data() {
    return {
      icon_code: JSON.parse(localStorage.getItem("businessTypeCode")),
      spinMessage: 'Saving......',
      spinning: false,
      configHistoryVisible: false,
      modalVisible: false,
      rowSelection: {},
      selectedRowKeys: [],
      scroll: {},
      dragging: false,
      enabled: true,
      selectedProduct: null,
      warn_at_zero_price: false,
      warn_at_zero_cost: false,
      warn_at_price_below_cost: false,
      notif_zero_price: false,
      notif_zero_cost: false,
      notif_price_below_cost: false,
      enable_regular: false,
      enable_packaged: false,
      enable_matrix: false,
      enable_kit: false,
      enable_virtual_kit: false,
      enable_non_inventory: false,
      enable_serial: false,
      enable_recipe: false,
      enable_combo: false,
      default_display: 10,
      data: [],
      fields: [],
      columns: columns,
      pagination: {
        pageSize: 10,
      },
      currentPage: 1,
      site_type: "ho",
      site_id: "",
      loading: false,
      filterStatus: "",
      profileAction: "",
      checkedFields: [],
      checkedItems: [],
      account_business_type: [],


      // checkedFields: (secureStorage.getItem("productDefaultColumns") == null) ?
      //  ["name", "barcode", "retail_price", "status"] :
      //  secureStorage.getItem("productDefaultColumns"),

      availableFields: [],
      errorMessage: null,
      successMessage: null,
      componentKey: 0,
      drawerVisible: false,
      visible: false,
      recipeVisible: false,
      apiURL: "",
      type: null,
      filterField: "name",
      filterCaption: "Filter by Name",
      searchText: null,
      params: {},
      stockCardVisible: false,
      stockCardKey: 0,
      windowWidth: 0,
      convertedJson: null,
      convertedJson2: null,
      width: 500,
      isAdmin: false,
      formSettings: { isAdmin: false },
      settingsGrouping: {},
      draggableKey: 0,
      massUpdateMode: false,
      title: "Product List",
      productType: "",
      productList: [],
      productListIds: [],
      filterParams: {},
      tags: [],
      allowMultiple: false,
      fileList: [],
      errors: [],
      accessRights: [],
      copyData: [],
      recipeKey: 0,
      btnValue: 0,
      initialSettings: {},
      logSettings: {},
      diffSettings: [],
      accountId: 0,
      showAdvanceImportExportModule: false,
    };
  },
  watch: {
    currentApiURL: function () {
      this.apiURL = this.currentApiURL;
    },
    parameters: function () {
      this.apiURL = this.currentApiURL;
      this.apiURL = this.apiURL + this.parameters;
      this.$refs.vuetable.selectedTo = [];
      this.checkedItems = [];
    },
    massUpdateMode: function () {
      if (this.massUpdateMode == true) {
        this.title = "Mass Update Products";
      } else {
        this.title = "Product List";
      }
      this.componentKey++;
    },
    checkedFields: function () {
      if (!this.checkedFields.length) {
        this.$notification['warning']({
          message: 'Customized columns cannot be empty',
          description: 'Columns reset to default.',
          placement: 'bottomRight'
        })
        this.checkedFields = ["name", "barcode", "status", "retail_price"]
        // this.fields = ["__checkbox", "id", "code", "name", "status", "__slot:actions"]
      }
    },
  },

  mounted: async function () {
    component_x = this;
    this.accessRights = this.$attrs.accessRights;
    this.params = this.$attrs.params;
    this.massUpdateMode = this.$attrs.massUpdateMode;
    this.rowSelection = {
      selectedRowKeys: this.selectedRowKeys,
      onChange: this.onSelectChange,
    };
    this.accountId = secureStorage.getItem("accountId")
    this.fetchAccountsAndCheck();
    // console.log("ProductsTableV2 : " + this.massUpdateMode)
    if (this.$attrs.filterParams != undefined) {
      this.filterParams = this.$attrs.filterParams;
    }

    if (this.$attrs.tags != undefined) {
      this.tags = this.$attrs.tags;
    }

    // on mount if localstorage exist add product to product list and product id to productlistid
    if (
      localStorage.productList &&
      component_x.params.productList == null &&
      component_x.massUpdateMode == true
    ) {
      component_x.productList = JSON.parse(localStorage.productList);
      var ids = component_x.productList.map(function (value) {
        return value.id;
      });
      component_x.productListIds = ids;
    }

    if (this.params.productList != undefined) {
      this.productList = this.params.productList;
      var ids = this.productList.map(function (value) {
        return value.id;
      });
      this.productListIds = ids;
    }

    if (this.params.massUpdateMode != undefined) {
      this.massUpdateMode = this.params.massUpdateMode;
    }

    if (this.params.tableParams != undefined) {
      this.params = this.params.tableParams;
    }

    var jsonField;
    jsonField = await HTTPRequest.getRequest(
      this.endPoint + "dynamic_forms/PXConfiguration?field_name=profile_name",
      null,
      null
    );
    this.convertedJson = ObjGen.xJson(jsonField.template, { numSpaces: 2 });

    //Parse Configuration
    //1960
    secureStorage.setItem("documentTypeId", -2);
    let congfigData = JSON.parse(this.convertedJson).groups
    for (let i = 0; i < congfigData.length; i++) {
      var group = JSON.parse(this.convertedJson).groups[i].name.replace(
        " ",
        ""
      );
      var subGroups = JSON.parse(this.convertedJson).groups[i].subGroups;
      for (let s = 0; s < subGroups.length; s++) {
        var groupName = group + '_' + JSON.parse(this.convertedJson).groups[i].subGroups[s].name
        var terminalSettings = JSON.parse(this.convertedJson).groups[i].subGroups[s].terminalSettings
        for (let t = 0; t < terminalSettings.length; t++) {
          let tS = JSON.parse(this.convertedJson).groups[i].subGroups[s]
            .terminalSettings[t];
          let tSN = tS.code != undefined ? tS.code : tS.header;
          let tSG = "groupName_" + (tS.code != undefined ? tS.code : tS.header);
          let tSV =
            tS.defaultValue != undefined
              ? tS.defaultValue
              : tS.type == "number"
                ? 0
                : tS.type == "boolean"
                  ? false
                  : "";
          var setting = [];
          if (tSN.includes("_")) setting.push({ [tSN]: tSV, [tSG]: groupName });
          this.initialSettings = Object.assign(
            this.initialSettings,
            setting[0]
          );
        }
      }
    }
    //Parse Configuration
    //1960

    this.site_id = secureStorage.getItem("defaultSiteId");

    let site = await HTTPRequest.getRequest(
      this.endPoint + "/sites/" + this.site_id,
      null
    );
    if (site != undefined) {
      this.site_type = site.site_type;
    }

    var userId = secureStorage.getItem("userId");
    var response;

    response = await HTTPRequest.getRequest(
      this.endPoint + "/user_settings?module_name=px&user_id=" + userId,
      null
    );
    var userSettings;
    if (response.data[0] != undefined) {
      userSettings = JSON.parse(response.data[0].settings_json);
    } else {
      userSettings = {};
    }

    response = await HTTPRequest.getRequest(
      this.endPoint + "/system_settings?module_name=px",
      null
    );
    var systemSettings;
    if (response.data[0] != undefined) {
      systemSettings = JSON.parse(response.data[0].settings_json);
    } else {
      systemSettings = {};
    }

    let userSettingHashSite = {};
    userSettingHashSite["site_id"] = this.site_id;

    let site_response;
    site_response = await HTTPRequest.getRequest(
      this.endPoint +
      "/user_settings?module_name=site_product&user_id=" +
      userId,
      null
    );
    if (site_response.data.length == 0) {
      let createParams = {
        user_setting: {
          module_name: "site_product",
          user_id: userId,
          settings_json: JSON.stringify(userSettingHashSite),
        },
      };
      await HTTPRequest.postRequest(
        this.endPoint + "/user_settings",
        null,
        createParams
      );
    } else {
      let updateParams = {
        user_setting: {
          module_name: "site_product",
          user_id: userId,
          settings_json: JSON.stringify(userSettingHashSite),
        },
      };
      await HTTPRequest.putRequest(
        this.endPoint + "/user_settings/" + site_response.data[0].id,
        null,
        updateParams
      );
    }

    var mergedHash = Object.assign({}, systemSettings, userSettings);
    this.formSettings = mergedHash;
    var defaultValues = []
    Object.keys(mergedHash).forEach(function (key) { defaultValues.push(key) });
    for (var i = 0; i < defaultValues.length; i++) {
      this.initialSettings[defaultValues[i]] = this.formSettings[defaultValues[i]]
    }

    if (this.formSettings.default_display != undefined) {
      if (this.formSettings.default_display.trim() != "") {
        this.default_display = this.formSettings.default_display;
        this.initialSettings["default_display"] =
          this.formSettings.default_display;
        this.pagination.pageSize = Number(this.default_display);
      }
    }

    if (this.formSettings.enable_combo != undefined) {
      this.enable_combo = this.formSettings.enable_combo;
      this.initialSettings["enable_combo"] = this.formSettings.enable_combo;
    }

    if (this.formSettings.enable_regular != undefined) {
      this.enable_regular = this.formSettings.enable_regular;
      this.initialSettings["enable_regular"] = this.formSettings.enable_regular;
    }

    if (this.formSettings.enable_packaged != undefined) {
      this.enable_packaged = this.formSettings.enable_packaged;
      this.initialSettings["enable_packaged"] =
        this.formSettings.enable_packaged;
    }

    if (this.formSettings.enable_matrix != undefined) {
      this.enable_matrix = this.formSettings.enable_matrix;
      this.initialSettings["enable_matrix"] = this.formSettings.enable_matrix;
    }

    if (this.formSettings.enable_kit != undefined) {
      this.enable_kit = this.formSettings.enable_kit;
      this.initialSettings["enable_kit"] = this.formSettings.enable_kit;
    }

    if (this.formSettings.enable_virtual_kit != undefined) {
      this.enable_virtual_kit = this.formSettings.enable_virtual_kit;
      this.initialSettings["enable_virtual_kit"] =
        this.formSettings.enable_virtual_kit;
    }

    if (this.formSettings.enable_non_inventory != undefined) {
      this.enable_non_inventory = this.formSettings.enable_non_inventory;
      this.initialSettings["enable_non_inventory"] =
        this.formSettings.enable_non_inventory;
    }

    if (this.formSettings.enable_serial != undefined) {
      this.enable_serial = this.formSettings.enable_serial;
      this.initialSettings["enable_serial"] = this.formSettings.enable_serial;
    }

    if (this.formSettings.enable_recipe != undefined) {
      this.enable_recipe = this.formSettings.enable_recipe;
      this.initialSettings["enable_recipe"] = this.formSettings.enable_recipe;
    }

    if (this.formSettings.warn_at_zero_cost != undefined) {
      this.warn_at_zero_cost = this.formSettings.warn_at_zero_cost;
      this.initialSettings["warn_at_zero_cost"] =
        this.formSettings.warn_at_zero_cost;
    }

    if (this.formSettings.warn_at_zero_price != undefined) {
      this.warn_at_zero_price = this.formSettings.warn_at_zero_price;
      this.initialSettings["warn_at_zero_price"] =
        this.formSettings.warn_at_zero_price;
    }

    if (this.formSettings.warn_at_price_below_cost != undefined) {
      this.warn_at_price_below_cost =
        this.formSettings.warn_at_price_below_cost;
      this.initialSettings["warn_at_price_below_cost"] =
        this.formSettings.warn_at_price_below_cost;
    }

    if (
      this.warn_at_zero_cost == true ||
      this.warn_at_zero_price == true ||
      this.warn_at_price_below_cost == true
    ) {
      var zero_cost_data = await HTTPRequest.getRequest(
        component_x.endPoint + "products/get_zero_products",
        null
      );
      if (this.warn_at_zero_price == true) {
        if (
          zero_cost_data.zero_price_total > 0 &&
          component_x.notif_zero_price == false
        ) {
          this.$notification["warn"]({
            message: "Warning",
            description: "There are items with Zero Price.",
          });
          component_x.notif_zero_price = true;
        }
      }

      if (this.warn_at_zero_cost == true) {
        if (
          zero_cost_data.zero_cost_total > 0 &&
          component_x.notif_zero_cost == false
        ) {
          this.$notification["warn"]({
            message: "Warning",
            description: "There are items with Zero Cost.",
          });
          component_x.notif_zero_cost = true;
        }
      }

      if (this.warn_at_price_below_cost == true) {
        if (
          zero_cost_data.price_below_cost_total > 0 &&
          component_x.notif_price_below_cost == false
        ) {
          this.$notification["warn"]({
            message: "Warning",
            description: "The price of an item is below than cost/landed cost.",
          });
          component_x.notif_price_below_cost = true;
        }
      }
    }

    this.fetch(this.params);


    var response = await HTTPRequest.getRequest(
      this.endPoint + "products/get_viewable_fields",
      null
    );
    // console.log(response["fields"]);
    this.availableFields = response["fields"];

    // rename tax_type into vat_type
    this.availableFields = this.availableFields.map((field) => {
      if (field == 'tax_type') {
        return 'vat_type';
      }else{
        return field;
      }
    })

    this.$nextTick(function () {
      //for fullscreen drawer
      window.addEventListener("resize", this.getWindowWidth);
      this.getWindowWidth();
    });
    // check on mount if localstorage productlist exisi -> then remove it
    this.clearProductListLocalStorage();

    let productsTableCustomList = localStorage.productsTableCustomList
    if (productsTableCustomList != undefined && productsTableCustomList != null) {
      this.columns = JSON.parse(productsTableCustomList)
    } else {
      this.columns = columns
    }

    // These lines will check for localStorage if there are existing checked fields if there's none, it will give default value
    let checkedfields = localStorage.checkedFields
    // console.log(checkedfields);
    if (checkedfields != undefined && checkedfields != null) {
      component_x.checkedFields = JSON.parse(checkedfields)
    } else {
      component_x.checkedFields = ["name", "barcode", "retail_price", "status"]
    }
    this.scroll = { x: 200 * this.checkedFields.length + 300, y: 500 };
    // it ends here


  },
  beforeDestroy() {
    //for fullscreen drawer
    window.removeEventListener("resize", this.getWindowWidth);
  },

  destroyed: async function () {
    // console.log(this.$route)
    localStorage.removeItem("productList");
    // if productlist exist and route is still product explorer add to local storage
    if (this.productList.length > 0 && this.$route.name == "product explorer") {
      localStorage.setItem("productList", JSON.stringify(this.productList));
    }
  },
  methods: {
      async fetchAccountsAndCheck() {
        const accountId = secureStorage.getItem("accountId");
        try {
            const allAccounts =  await HTTPRequest.getRequest(this.endPoint + "accounts/get_valid_accounts", null);
            const filteredAccounts = allAccounts.filter(account => {
                const name = account.account_name.toLowerCase();
                return name === "shakeys" || name === "periperi" || name == "irippledemo";
            });
            this.shakeysOrPeriAccountIds = filteredAccounts.map(acc => acc.id);
            console.log('check', this.shakeysOrPeriAccountIds, accountId)
            this.showAdvanceImportExportModule = this.shakeysOrPeriAccountIds.includes(Number(accountId)); 
        } catch (error) {
            // console.error("Failed to fetch accounts:", error);
        }
    },
    // clear local storage produclist
    clearProductListLocalStorage() {
      if (localStorage.productList) {
        localStorage.removeItem("productList");
      }
    },
    async importFile() {
      let formData = new FormData();
      formData.append("profile_name", "products");
      formData.append("file", this.fileList[0]);
      await axios({
        method: "post",
        url: this.endPoint + "importers/upload_file",
        headers: {
          Authorization: "Bearer " + secureStorage.getItem("accessToken"),
          "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-File"
        },
        data: formData,
      }).then(async function (m) {
        // alert(m.data.file_name)
        var payload = {
          import_job: { profile_name: "products", file_name: m.data.file_name },
        };
        var response = await HTTPRequest.postRequest(
          component_x.endPoint + "/import_jobs",
          null,
          payload
        );
        if (response.id != null) {
          component_x.$notification["success"]({
            message: "Successful Operation",
            description:
              "File has been uploaded. Your importation is ongoing, you can check the ongoing jobs for updates.",
            btn: (h) => {
              return h(
                "base-button",
                {
                  props: {
                    type: "primary",
                    class: "btn-sm",
                  },
                  on: {
                    click: () => component_x.$router.push("/jobs"),
                  },
                },
                "View Jobs"
              );
            },
          });
          component_x.drawerVisible = false;
        }
        // console.log(response)
      });
      // .catch(function () {
      //     alert("NOT OKAY")
      // });
    },

    async massupdate(field_name, value) {
      var field_update = {};
      this.modalVisible = false;
      field_update[field_name] = value;
      var payload = {
        ids: this.selectedRowKeys,
        field_update: field_update,
      };
      var response = await HTTPRequest.postRequest(
        this.endPoint + "products/mass_update",
        null,
        payload
      );
      if (response["message"] == "Ok") {
        this.$notification["success"]({
          message: "Update Successful",
          description: "Mass update of selected product suceeded.",
        });
        this.fetch(this.params);
        this.selectedRowKeys = [];
      } else {
        this.$notification["error"]({
          message: "Update Failed",
          description:
            "Mass update of selected product failed. " + response["error"],
        });
      }
    },
    handleRemove(file) {
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
    },
    beforeUpload(file) {
      this.fileList = [...this.fileList, file];
      return false;
    },
    onSelectChange(selectedRowKeys) {
      // console.log('selectedRowKeys changed: ', selectedRowKeys);
      this.selectedRowKeys = selectedRowKeys;
    },
    async showMassUpdater() {
      this.productList.forEach((product) => {
        if (product.product_type == "M") {
          axios({
            method: "GET",
            url:
              this.endPoint +
              "products/get_matrix_items?matrix_parent_id=" +
              product.id +
              "&mass_update=true",
            headers: {
              Authorization: "Bearer " + secureStorage.getItem("accessToken"),
              "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web"
            },
          }).then((response) => {
            if (response.data.length >= 1) {
              product.children = response.data;
            }
          });
        }
        return product;
      });

      this.$router.push({
        name: "product_updates",
        params: {
          productList: this.productList,
          tableParams: this.params,
          filterParams: this.filterParams,
          tags: this.tags,
        },
      });
    },
    addToProductList(id) {
      if (this.productListIds.includes(id.id)) {
        var indexValue = this.productListIds.indexOf(id.id);
        this.productList.splice(indexValue, 1);
      } else {
        this.productList.push({ id: id.id, name: id.name, barcode: id.barcode, stock_no: id.stock_no, product_type: id.product_type, product_grade_level: id.product_grade_level, product_group: { name: (id.product_group == null) ? null : id.product_group.name } });
        // console.log("ewan 2")
      }
      var ids = this.productList.map(function (value) {
        return value.id;
      });
      this.productListIds = ids;
    },
    // select all function
    changeMode() {
      this.massUpdateMode = !this.massUpdateMode;
      if (this.massUpdateMode == true) {
        this.$notification["info"]({
          message: "Note",
          description: "Click Add to include product in the Update List",
        });
      } else {
        // secureStorage.deleteItem("productList")
        this.productList = [];
        this.massUpdateMode = false;
        this.productListIds = [];
        this.params = "";
      }
      this.$emit(
        "changeMode",
        this.massUpdateMode,
        this.productList,
        this.params
      );
    },

    updateTableList() {
      var reference_array = this.availableFields;
      var array = this.checkedFields;
      if (array.length) {
        array.sort(function (a, b) {
          return reference_array.indexOf(a) - reference_array.indexOf(b);
        });
        this.checkedFields = array;
      } else {
        this.checkedFields = ["name", "barcode", "retail_price", "status"];
        this.$notification['warning']({
          message: 'Customized columns cannot be empty',
          description: 'Columns reset to default.'
        })
      }

      // secureStorage.setItem("productDefaultColumns", array);

      this.scroll = { x: 200 * array.length + 300, y: 500 };

      var updatedColumns = [];
      for (var i = 0; i < this.checkedFields.length; i++) {
        var title;
        var column;
        title = _.startCase(this.checkedFields[i]);
        var derived_values = [
          "category_name",
          "section_name",
          "department_name",
          "division_name",
        ];
        var valueToDisplay = this.checkedFields[i];
        // if (derived_values.includes(this.checkedFields[i])) {
        //   valueToDisplay = "category_tree['" + this.checkedFields[i] + "']";
        // }
        if (i == 0) {
          column = {
            title: title,
            width: 200,
            dataIndex: valueToDisplay,
            key: this.checkedFields[i],
            fixed: "left",
            scopedSlots: { customRender: "name" }
          };
        } else {
          if(valueToDisplay == 'status'){
            column = {
            title: title,
            dataIndex: valueToDisplay,
            key: this.checkedFields[i],
            width: 200,
            scopedSlots: { customRender: "status" }
            };
          } else if(valueToDisplay == 'product_type'){
            column = {
            title: title,
            dataIndex: valueToDisplay,
            key: this.checkedFields[i],
            width: 200,
            scopedSlots: { customRender: "product_type" }
            };
          }else if(valueToDisplay == 'vat_type'){
            column = {
              title: 'Vat Type',
              dataIndex: 'tax_type',
              key: 'tax_type',
              width: 200,
              };
          }else{
            column = {
              title: title,
              dataIndex: valueToDisplay,
              key: this.checkedFields[i],
              width: 200,
            };
          }
        }
        updatedColumns.push(column);
      }

      var actionColumn = {
        title: "Action",
        key: "operation",
        fixed: "right",
        width: 300,
        scopedSlots: { customRender: "action" },
      };
      updatedColumns.push(actionColumn);
      this.columns = updatedColumns;
      localStorage.setItem("checkedFields", JSON.stringify(this.checkedFields));
      localStorage.setItem("productsTableCustomList", JSON.stringify(updatedColumns));
      this.onClose();
    },
    showModal(product) {
      this.stockCardVisible = true;
      this.selectedProduct = product.id;
      this.stockCardKey++;
    },
    filterProducts() {
      this.params[this.filterField] = this.searchText;
      this.fetch(this.params);
    },
    changeFilter(field) {
      this.filterField = field;
      this.filterCaption = "Filter By " + _.startCase(this.filterField);
    },
    handleTableChange(pagination, filters, sorter) {
      filters = this.params;
      var pager = { ...this.pagination };
      pager.current = pagination.current;
      pager.pageSize = Number(this.default_display);
      this.pagination = pager;
      this.currentPage = pagination.current;
      this.fetch({
        results: Number(this.default_display),
        page: pagination.current,
        ...filters,
      });
    },
    fetch(params = {}) {
      // console.log('fetch params:', params);
      this.loading = true;
      let additional_product_params = "";
      // if (this.site_type == "branch") {
      let siteId = secureStorage.getItem("defaultSiteId");
      additional_product_params = "&site_id=" + this.site_id;
      // }

      reqwest({
        url:
          this.endPoint +
          "products?per_page=" +
          this.default_display +
          "&all=1" +
          additional_product_params,
        method: "get",
        headers: {
          Authorization: "Bearer " + secureStorage.getItem("accessToken"),
          "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web"
        },
        data: {
          results: Number(this.default_display),
          ...params,
        },
      }).then((response) => {
        // console.log("data",response)
        var pagination = { ...this.pagination };
        pagination.total = response.total;
        pagination.pageSize = Number(this.default_display);
        // pagination.current = response.current_page
        var productData = response.data;
        this.data = productData.slice(0);
        this.data.forEach((product) => {
          let retail_price = Number(product.retail_price);
          let site_retail_price = Number(product.site_retail_price);

          product.site_retail_price = site_retail_price
            .toFixed(2)
            .replace(/\d(?=(\d{3})+\.)/g, "$&,");
          product.retail_price = retail_price
            .toFixed(2)
            .replace(/\d(?=(\d{3})+\.)/g, "$&,");
        });
        var copyData = JSON.parse(JSON.stringify(productData));
        // productData.forEach(function(v) { copyData.push(v) });
        // this.copyData = productData.slice(0);
        // var productDataCopy = [...productData]
        copyData.map(function (item) {
          delete item.children;
          return item;
        });
        this.copyData = copyData;
        // console.log("*******")
        // console.log(productData)
        // console.log(productDataCopy)

        this.loading = false;
        this.pagination = pagination;
      });
    },
    addAllProduct() {
      let products = this.copyData;
      // console.log(products)
      products.forEach((product) => {
        this.addToProductList(product);
      });
    },
    ...mapActions(["updateProfileId", "updateParentId"]),
    getWindowWidth(event) {
      //for fullscreen drawer
      this.windowWidth = window.innerWidth;
    },
    closeDrawer() {
      this.onClose();
    },
    refreshPage(event, action="") {
      this.onClose();
      this.successMessage = "Successful Operation";
      this.errorMessage = null;

      if(action === 'update'){
        var payload = {
          results: Number(this.default_display),
          page: this.currentPage,
          ...this.params
        }   
        this.fetch(payload);
      }else{
        this.fetch(this.params);
      }
      
    },
    onRowClick(dataItem) {
      this.updateParentId(dataItem.id);
    },
    onRowClass(dataItem) {
      return dataItem.id == this.parentId ? "table-success" : "";
    },
    showDrawer(id, type, btn) {
      this.btnValue = btn;
      if (type == "R") {
        this.recipeKey++;
        this.updateProfileId(id);
        this.productType = "R";
        this.recipeVisible = true;
      } else {
        this.componentKey++;
        this.updateProfileId(id);
        this.productType = type;
        this.visible = true;
      }
    },
    showRecipeDrawer(id) {
      this.recipeKey++;
      this.updateProfileId(id);
      this.productType = "R";
      this.recipeVisible = true;
    },
    updateSettings(formSettings, settingsGrouping) {
      this.formSettings = formSettings;
      this.settingsGrouping = settingsGrouping;
    },
    validateConfig(userSettings, globalSettings) {
      this.errors = [];
      if (
        globalSettings.short_name_length != undefined &&
        globalSettings.short_name_length != ""
      ) {
        if (globalSettings.short_name_length < 1) {
          this.errors.push("Lenght of Short Name must be greater than zero");
        } else if (globalSettings.short_name_length > 50) {
          this.errors.push(
            "Lenght of Short Name must be less than or equal to 50"
          );
        }
      }

      if (
        userSettings.default_markup != undefined &&
        userSettings.default_markup != ""
      ) {
        this.errors.push(
          ValidateField.requiredButAllowZero(
            "Markup Percent",
            userSettings.default_markup
          )
        );
      }

      if (
        userSettings.default_vat_rate != undefined &&
        userSettings.default_vat_rate != ""
      ) {
        this.errors.push(
          ValidateField.greaterThanZero(
            "VAT Rate Percent",
            userSettings.default_vat_rate
          )
        );
      }

      if (
        userSettings.markup_roundup != undefined &&
        userSettings.markup_roundup != ""
      ) {
        this.errors.push(
          ValidateField.greaterThanZero(
            "Roundup To",
            userSettings.markup_roundup
          )
        );
      }

      if (
        userSettings.default_display != undefined &&
        userSettings.default_display != ""
      ) {
        this.errors.push(
          ValidateField.greaterThanZero(
            "No. of Lines",
            userSettings.default_display
          )
        );
        this.errors.push(
          ValidateField.wholeNumberFormat(
            "No. of Lines",
            userSettings.default_display
          )
        );
      }

      document.getElementsByClassName(
        "ant-drawer-wrapper-body"
      )[0].scrollTop = 0;
      this.errors = this._.compact(this.errors);
      return this.errors.length;
    },
    async processSettings() {
      this.spinning = true;
      var userSettings = this.settingsGrouping["User Settings"];
      var globalSettings = this.settingsGrouping["Global Settings"];
      var userSettingHash = {};
      var globalSettingHash = {};
      var formSettings = this.formSettings;
      var initialSettings = this.initialSettings
      var endPoint = this.endPoint

      Object.keys(formSettings).forEach(function (key) {
        var value = formSettings[key];
        if (userSettings.includes(key)) {
          userSettingHash[key] = value;
        }
        if (globalSettings.includes(key)) {
          globalSettingHash[key] = value;
        }

        //1960
        if (Object.keys(initialSettings).includes(key) && value != initialSettings[key]) {

          var configHistoryPayload = {
            config: initialSettings['groupName_' + key],
            config_type: key,
            config_from: initialSettings[key],
            config_to: value,
            config_at: moment(new Date()),
            config_by: secureStorage.getItem("userName"),
            config_account: secureStorage.getItem("accountId"),
            document_type: -2
          }
          // Save config changes
          HTTPRequest.postRequest(
            endPoint + "document_configuration_histories/",
            null,
            configHistoryPayload
          );
          initialSettings[key] = value;
        }
      });
      this.initialSettings = initialSettings

      if (!this.validateConfig(userSettingHash, globalSettingHash)) {
        var userId = secureStorage.getItem("userId");
        var response;
        response = await HTTPRequest.getRequest(
          this.endPoint + "/user_settings?module_name=px&user_id=" + userId,
          null
        );
        if (response.data.length == 0) {
          var createParams = {
            user_setting: {
              module_name: "px",
              user_id: userId,
              settings_json: JSON.stringify(userSettingHash),
            },
          };
          await HTTPRequest.postRequest(
            this.endPoint + "/user_settings",
            null,
            createParams
          );
        } else {
          var updateParams = {
            user_setting: {
              module_name: "px",
              user_id: userId,
              settings_json: JSON.stringify(userSettingHash),
            },
          };
          await HTTPRequest.putRequest(
            this.endPoint + "/user_settings/" + response.data[0].id,
            null,
            updateParams
          );
        }

        response = await HTTPRequest.getRequest(
          this.endPoint + "/system_settings?module_name=px",
          null
        );
        if (response.data.length == 0) {
          var createParams2 = {
            system_setting: {
              module_name: "px",
              settings_json: JSON.stringify(globalSettingHash),
            },
          };
          await HTTPRequest.postRequest(
            this.endPoint + "/system_settings",
            null,
            createParams2
          );
        } else {
          var updateParams2 = {
            system_setting: {
              module_name: "px",
              settings_json: JSON.stringify(globalSettingHash),
            },
          };
          await HTTPRequest.putRequest(
            this.endPoint + "/system_settings/" + response.data[0].id,
            null,
            updateParams2
          );
        }
        alert("Update successful");
        this.closeDrawer();
      }
      this.spinning = false;
    },
    async showActionDrawer(action) {
      if (action == "customize_list") {
        // var response = await HTTPRequest.getRequest(this.endPoint + "products/get_viewable_fields",null)
        // this.availableFields = response["fields"]
        if (this.checkedFields.length == 0) {
          this.checkedFields = ["name", "barcode", "retail_price", "status"];
        }
      }

      if (action == "configuration") {
        this.width = 800;
        var userId = secureStorage.getItem("userId");
        var userGroupIds = await HTTPRequest.getRequest(
          this.endPoint + "users/show_user_memberships/?user_id=" + userId,
          null
        );
        var adminGroup = await HTTPRequest.getRequest(
          this.endPoint + "user_groups/Admin?field_name=name",
          null
        );
        if (userGroupIds.user_membership_ids.includes(adminGroup.id)) {
          this.isAdmin = true;
          this.formSettings.isAdmin = this.isAdmin;
        }
      } else if (action == "configurationhist") {
        this.configHistoryVisible = true
        this.width = 1100;
      } else {
        this.width = 500;
      }

      this.profileAction = action;
      this.drawerVisible = true;
    },
    onClose() {
      this.recipeVisible = false;
      this.drawerVisible = false;
      this.visible = false;
      this.componentKey++;
      this.recipeKey++;
    },
    log() {
      this.checkedItems = this.$refs.vuetable.selectedTo;
    },
    onCheckField(fieldName) {
      if (this.checkedFields.includes(fieldName)) {
        var indexValue = this.checkedFields.indexOf(fieldName);
        if (indexValue > -1) {
          this.checkedFields.splice(indexValue, 1);
        }
      } else {
        this.checkedFields.push(fieldName);
      }
    },
    onCheckAllField() {
      if (this.checkedFields.length == this.availableFields.length) {
        this.checkedFields = [];
      } else {
        this.checkedFields = Array.from(this.availableFields);
      }
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    async onLoadError(error) {
      // request for new token or reauthenticate
      if (error.response.status == 401) {
        var auth_response = await HTTPRequest.authenticate(
          component_x.endPoint
        );
        if (auth_response["status"] == "Ok") {
          this.$router.go();
        } else {
          alert("Cannot get access token. Please login again.");
          this.$router.push("/");
        }
      }
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    deleteRow(id) {
      axios({
        method: "delete",
        url: this.endPoint + this.currentProfile + "/" + id,
        headers: {
          Authorization: "Bearer " + secureStorage.getItem("accessToken"),
          "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web"
        },
      })
        .then(function () {
          component_x.successMessage = "Successfully deleted record";
          component_x.fetch(component_x.params);
        })
        .catch((error) => {
          if (error.response) {
            component_x.errorMessage = error.response.data.error;
          } else {
            alert("Invalid Credentials");
          }
        });
    },
    downloadTemplate(type) {
      var urlDownload;
      if (type == "1")
        urlDownload =
          this.endPoint +
          "import_templates/download_file?profile_name=products&type=basic";
      else if (type == "3")
        urlDownload =
          this.endPoint +
          "import_templates/download_file?profile_name=products&type=matrix";
      else
        urlDownload =
          this.endPoint +
          "import_templates/download_file?profile_name=products&type=advanced";
      axios({
        url: urlDownload,
        method: "POST",
        responseType: "blob", // important
        headers: {
          Authorization: "Bearer " + secureStorage.getItem("accessToken"),
          "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-File"
        },
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "product_import_template.csv");
        document.body.appendChild(link);
        link.click();
        component_x.$notification["success"]({
          message: "Successful Download",
          description:
            "You have succesfully downloaded the template for product upload.",
        });
      });
    },
    download() {
      var payload = {};
      var additional_parameters = "";
      var baseUrl =
        this.endPoint + "products/download?file_type=csv&action_type=export";
      if (this.filterStatus == "0") {
        // All
        payload["type"] = "all";
      } else if (this.filterStatus == "2") {
        // Selected
        payload["type"] = "selected";
        payload["ids"] = this.selectedRowKeys;
      } else if (this.filterStatus == "3") {
        // Filtered
        payload["type"] = "filtered";
        var obj3 = Object.assign({}, payload, this.params);
        payload = obj3;
      } else if (this.filterStatus == "4") {
        // Site Products Only
        payload["type"] = "site_products_only";
        payload["site_id"] = this.site_id;
      } else if (this.filterStatus == "1") {
        baseUrl = this.endPoint + "products/product_master_export";
      }

      if (this.checkedFields.length == 0) {
        payload["fields"] = this.availableFields;
      } else {
        payload["fields"] = this.checkedFields;
      }

      axios({
        url: baseUrl + additional_parameters,
        method: this.filterStatus == "1" ? "GET" : "POST",
        responseType: "blob", // important
        headers: {
          Authorization: "Bearer " + secureStorage.getItem("accessToken"),
          "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-File"
        },
        data: payload,
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", this.filterStatus == "1" ? "product_master.csv" : "products.csv");
        document.body.appendChild(link);
        link.click();
        this.onClose();
        this.filterStatus = null;
        // this.successMessage = "Download successful"
        this.$notification["success"]({
          message: "Download Successful",
          description: "You have successfully downloaded your product list.",
        });
      });
    },
    displayMessage(message) {
      if (message["error"] != undefined) {
        this.onClose();
        this.errorMessage = message["error"];
        this.successMessage = null;
      }
    },
    removeMessage(type) {
      if (type == "error") this.errorMessage = null;
      else this.successMessage = null;
    },
    iconSourcePath(product_type){
      var image_path = "";
      switch(product_type){
        case '':
          image_path =  require('../../assets/icons/'+ this.icon_code + '/regular.png')
          break;
        case 'P':
          image_path =  require('../../assets/icons/'+ this.icon_code + '/packaged.png')
          break;
        case 'N':
          image_path =  require('../../assets/icons/'+ this.icon_code + '/non_inventory.png')
          break;
        case 'S':
          image_path =  require('../../assets/icons/'+ this.icon_code + '/serial.png')
          break;
        case 'K':
          image_path =  require('../../assets/icons/'+ this.icon_code + '/kit.png')
          break;
        case 'V':
          image_path =  require('../../assets/icons/'+ this.icon_code + '/virtual_kit.png')
          break;
        case 'M':
          image_path =  require('../../assets/icons/'+ this.icon_code + '/matrix.png')
          break;
        case 'B':
          if(this.icon_code == 'FNB'){
            image_path =  require('../../assets/icons/'+ this.icon_code + '/combo.png')
          }else{
            image_path =  require('../../assets/icons/'+ this.icon_code + '/regular.png')
          }
          break;
        case 'R':
          image_path =  require('../../assets/icons/'+ this.icon_code + '/recipe.png')
          break;
        default:
          image_path =  require('../../assets/icons/'+ this.icon_code + '/regular.png')
          break;
      }
      return image_path;
    },
  },
};
</script>

<style>
.ant-table-row-level-1 {
  background-color: #e6f7ff;
}
.product-icons{
  margin-right: 7px;
  height: 15px;
  width: 15px;
}
.table-product-icons{
  position: absolute;
  margin: -23px;
  margin-top: 3px;
  height: 15px;
  widows: 15px;
}
</style>
